export default __webpack_public_path__ + "static/media/Colorly.9d42525e.png";